export const BASE_API_URL = process.env.REACT_APP_API_BASE_URL
  ? `${process.env.REACT_APP_API_BASE_URL}/api/v1`
  : "http://localhost:8080/api/v1";

export const INPUTADMIN = "input.admin";

export const API_URLS = {
  AUTH: {
    LOGIN: `${BASE_API_URL}/auth/login`,
    CHANGE_PASSWORD: `${BASE_API_URL}/auth/change_password`,
    RESET_PASSWORD: `${BASE_API_URL}/auth/reset_password`,
    REFRESH_TOKEN: `${BASE_API_URL}/auth/refresh_token`,
  },
  USER: {
    GET_ALL_USERS: `${BASE_API_URL}/input/user-mgmt/get_users`,
    CREATE_USER: `${BASE_API_URL}/input/user-mgmt/create_user`,
    UPDATE_USER: `${BASE_API_URL}/input/user-mgmt/update_user`,
    DISABLE_USER: `${BASE_API_URL}/input/user-mgmt/delete_user`,
  },
  SERVICE_USER: {
    GET_ALL_SERVICE_USERS: `${BASE_API_URL}/input/service-user-mgmt/get_service_users`,
    CREATE_SERVICE_USER: `${BASE_API_URL}/input/service-user-mgmt/create_service_user`,
    UPDATE_SERVICE_USER: `${BASE_API_URL}/input/service-user-mgmt/update_service_user`,
    DISABLE_SERVICE_USER: `${BASE_API_URL}/input/service-user-mgmt/delete_service_user`,
    UPDATE_SERVICE_USER_STATUS: `${BASE_API_URL}/input/service-user-mgmt/update_service_user_status`,
  },
  COMPANY: {
    GET_COMPANIES: `${BASE_API_URL}/input/company-mgmt/get_companies`,
    CREATE_COMPANY: `${BASE_API_URL}/input/company-mgmt/create_company`,
    UPDATE_COMPANY: `${BASE_API_URL}/input/company-mgmt/update_company`,
    DELETE_COMPANY: `${BASE_API_URL}/input/company-mgmt/delete_company`,
    GET_COMPANY_WISE_SCAN_COUNT: `${BASE_API_URL}/input/company-mgmt/get_company_wise_scan_count`,
    GET_USERS_BY_COMPANY_ID: `${BASE_API_URL}/input/company-mgmt/get_users_by_company_id`,
    GET_REGION_ADMINS_BY_COMPANY_ID: `${BASE_API_URL}/input/company-mgmt/get_region_admins`,
    UPDATE_USER_STATUS: `${BASE_API_URL}/input/company-mgmt/update_user_status`,
    GET_MACHINES_BY_ID: `${BASE_API_URL}/input/company-mgmt/get_machines_by_id`,
    ATTACH_MACHINE: `${BASE_API_URL}/input/company-mgmt/attach_machine`,
    DETACH_MACHINE: `${BASE_API_URL}/input/company-mgmt/detach_machine`,
    GET_CROPS_BY_ID: `${BASE_API_URL}/input/company-mgmt/get_crops_by_id`,
    ATTACH_CROP: `${BASE_API_URL}/input/company-mgmt/attach_crop`,
    DETACH_CROP: `${BASE_API_URL}/input/company-mgmt/detach_crop`,
    GET_COMPANY_MACHINE_INSTANCES_BY_ID: `${BASE_API_URL}/input/company-mgmt/get_company_machine_instances_by_id`,
    GET_READY_INSTANCES_BY_MACHINE_ID: `${BASE_API_URL}/input/company-mgmt/get_ready_instances_by_machine_id`,
    ADD_COMPANY_MACHINE_INSTANCE: `${BASE_API_URL}/input/company-mgmt/add_company_machine_instance`,
    DELETE_COMPANY_MACHINE_INSTANCE: `${BASE_API_URL}/input/company-mgmt/delete_company_machine_instance`,
    GET_ALL_WINDOWS_ACCESS_PASSWORDS: `${BASE_API_URL}/input/company-mgmt/get_all_windows_access_password`,
    GET_WINDOWS_ACCESS_PASSWORD: `${BASE_API_URL}/input/company-mgmt/get_windows_access_password`,
    CREATE_WINDOWS_ACCESS_PASSWORD: `${BASE_API_URL}/input/company-mgmt/create_windows_access_password`,
  },
  COMPANY_CONFIG: {
    CREATE_COMPANY_CONFIG: `${BASE_API_URL}/input/company-config-mgmt/create_company_config`,
    GET_COMPANY_CONFIG_BY_ID: `${BASE_API_URL}/input/company-config-mgmt/get_company_config`,
    UPDATE_COMPANY_CONFIG: `${BASE_API_URL}/input/company-config-mgmt/update_company_config`,
    DELETE_COMPANY_CONFIG: `${BASE_API_URL}/input/company-config-mgmt/delete_company_config`,
    GET_COMPANY_CONFIG_DETAILS_BY_COMPANY_ID: `${BASE_API_URL}/input/company-config-mgmt/get_company_config_details`,
    GET_VARIETIES_AND_MACHINES_BY_CROP_ID: `${BASE_API_URL}/input/company-config-mgmt/get_varieties_and_machines_by_crop_id`,
  },
  ROLE: {
    GET_ROLES: `${BASE_API_URL}/input/role-mgmt/get_roles`,
    CREATE_ROLE: `${BASE_API_URL}/input/role-mgmt/create_role`,
    UPDATE_ROLE: `${BASE_API_URL}/input/role-mgmt/update_role`,
    DELETE_ROLE: `${BASE_API_URL}/input/role-mgmt/delete_role`,
    GET_ROLE_NAMES: `${BASE_API_URL}/input/role-mgmt/get_role_names`,
  },
  CLASS: {
    GET_CLASSES: `${BASE_API_URL}/input/class-mgmt/get_classes`,
    CREATE_CLASS: `${BASE_API_URL}/input/class-mgmt/create_class`,
    UPDATE_CLASS: `${BASE_API_URL}/input/class-mgmt/update_class`,
    DELETE_CLASS: `${BASE_API_URL}/input/class-mgmt/delete_class`,
  },
  CROP: {
    GET_CROPS: `${BASE_API_URL}/input/crop-mgmt/get_crops`,
    CREATE_CROP: `${BASE_API_URL}/input/crop-mgmt/create_crop`,
    UPDATE_CROP: `${BASE_API_URL}/input/crop-mgmt/update_crop`,
    DELETE_CROP: `${BASE_API_URL}/input/crop-mgmt/delete_crop`,
  },
  CROP_CONFIG: {
    CREATE_CROP_CONFIG: `${BASE_API_URL}/input/crop-config-mgmt/create_crop_config`,
    GET_VARITIES_AND_MACHINES_BY_CROP_ID: `${BASE_API_URL}/input/crop-config-mgmt/get_varieties_and_machines_by_crop_id`,
    GET_CROP_CONFIG_BY_ID: `${BASE_API_URL}/input/crop-config-mgmt/get_crop_config`,
    UPDATE_CROP_CONFIG: `${BASE_API_URL}/input/crop-config-mgmt/update_crop_config`,
    DELETE_CROP_CONFIG: `${BASE_API_URL}/input/crop-config-mgmt/delete_crop_config`,
    GET_CROP_CONFIG_DETAILS_BY_CROP_ID: `${BASE_API_URL}/input/crop-config-mgmt/get_crop_config_details`,
  },
  VARIETY: {
    GET_VARIETIES: `${BASE_API_URL}/input/variety-mgmt/get_varieties_by_crop_id`,
    CREATE_VARIETY: `${BASE_API_URL}/input/variety-mgmt/create_variety`,
    UPDATE_VARIETY: `${BASE_API_URL}/input/variety-mgmt/update_variety`,
    DELETE_VARIETY: `${BASE_API_URL}/input/variety-mgmt/delete_variety`,
  },
  MACHINE: {
    GET_MACHINES: `${BASE_API_URL}/input/machine-mgmt/get_machines`,
    CREATE_MACHINE: `${BASE_API_URL}/input/machine-mgmt/create_machine`,
    UPDATE_MACHINE: `${BASE_API_URL}/input/machine-mgmt/update_machine`,
    DELETE_MACHINE: `${BASE_API_URL}/input/machine-mgmt/delete_machine`,
  },
  MACHINE_INSTANCE: {
    GET_INSTANCES: `${BASE_API_URL}/input/machine-instance-mgmt/get_instances_by_machine_versions`,
    CREATE_INSTANCE: `${BASE_API_URL}/input/machine-instance-mgmt/create_machine_instance`,
    DELETE_INSTANCE: `${BASE_API_URL}/input/machine-instance-mgmt/delete_machine_instance`,
  },
  MACHINE_VERSION: {
    GET_VERSIONS: `${BASE_API_URL}/input/machine-version-mgmt/get_versions_by_machine_id`,
    CREATE_VERSION: `${BASE_API_URL}/input/machine-version-mgmt/create_machine_version`,
    UPDATE_VERSION: `${BASE_API_URL}/input/machine-version-mgmt/update_machine_version`,
    DELETE_VERSION: `${BASE_API_URL}/input/machine-version-mgmt/delete_machine_version`,
  },
  LOCATION: {
    GET_LOCATIONS: `${BASE_API_URL}/input/location-mgmt/get_locations_by_company_id`,
    CREATE_LOCATION: `${BASE_API_URL}/input/location-mgmt/create_location`,
    UPDATE_LOCATION: `${BASE_API_URL}/input/location-mgmt/update_location`,
    DELETE_LOCATION: `${BASE_API_URL}/input/location-mgmt/delete_location`,
  },
  METADATA: {
    CREATE_METADATA: `${BASE_API_URL}/input/metadata-mgmt/create_metadata`,
    GET_METADATA_BY_COMPANY_ID: `${BASE_API_URL}/input/metadata-mgmt/get_metadata_by_company_id`,
    UPDATE_METADATA: `${BASE_API_URL}/input/metadata-mgmt/update_metadata`,
    DELETE_METADATA: `${BASE_API_URL}/input/metadata-mgmt/delete_metadata`,
    GET_METADATA_TYPES: `${BASE_API_URL}/input/metadata-mgmt/get_metadata_types`,
  },
  CALIBRATION: {
    GET_CALIBRATION_DATA: `${BASE_API_URL}/input/calibration-mgmt/get_all_calibration_data`,
  },
};
